module.exports = __webpack_public_path__ + "static/media/rapidez.c3d9fde9.png";